import styled from 'styled-components';

const SKELETON_ROWS = 10;

const RiderTableSkeleton = () => {
    return (
        <MainWrapper>
            <SkeletonGrid>
                {/* Header */}
                <SkeletonHeader>
                    <SkeletonHeaderRow>
                        <SkeletonHeaderCell width="60px" />
                        <SkeletonHeaderCell width="110px">First Name</SkeletonHeaderCell>
                        <SkeletonHeaderCell width="110px">Last Name</SkeletonHeaderCell>
                        <SkeletonHeaderCell width="110px">Team</SkeletonHeaderCell>
                        <SkeletonHeaderCell width="110px">Graduation Year</SkeletonHeaderCell>
                        <SkeletonHeaderCell width="110px">Zip</SkeletonHeaderCell>
                    </SkeletonHeaderRow>
                </SkeletonHeader>

                {/* Body Rows */}
                <SkeletonBody>
                    {Array.from({ length: SKELETON_ROWS }).map((_, index) => (
                        <SkeletonRow key={index} isAlt={index % 2 !== 0}>
                            <SkeletonCell width="60px">
                                <SkeletonCheckbox />
                            </SkeletonCell>
                            <SkeletonCell width="110px">
                                <SkeletonLine />
                            </SkeletonCell>
                            <SkeletonCell width="110px">
                                <SkeletonLine />
                            </SkeletonCell>
                            <SkeletonCell width="110px">
                                <SkeletonLine />
                            </SkeletonCell>
                            <SkeletonCell width="110px">
                                <SkeletonLine />
                            </SkeletonCell>
                            <SkeletonCell width="110px">
                                <SkeletonLine />
                            </SkeletonCell>
                        </SkeletonRow>
                    ))}
                </SkeletonBody>
            </SkeletonGrid>
        </MainWrapper>
    );
};

const MainWrapper = styled.div`
  width: 100%;
`;

const SkeletonGrid = styled.div`
  border: 1px solid #5e5e5e;
  border-radius: 20px;
  background: transparent;
  overflow: hidden;
`;

const SkeletonHeader = styled.div`
  background: #373737;
  border-radius: 20px 20px 0px 0px;
`;

const SkeletonHeaderRow = styled.div`
  display: flex;
  border: none;
  justify-content: space-between;
`;

const SkeletonHeaderCell = styled.div<{ width: string }>`
  width: ${props => props.width};
  padding: 12px 8px;
  border: none;
  display: flex;
  align-items: center;
  color: #717171;
  font-size: 12px;
  font-weight: 500;
`;

const SkeletonBody = styled.div`
  background: transparent;
`;

const SkeletonRow = styled.div<{ isAlt: boolean }>`
  display: flex;
  background: ${props => (props.isAlt ? '#333333' : '#2d2d2e')} !important;
  border: none;
  align-items: center;
 justify-content: space-between;
  &:not(:last-child) {
    border-bottom: none;
  }
`;

const SkeletonCell = styled.div<{ width: string }>`
  width: ${props => props.width};
  padding: 12px 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: ${props => (props.width === '60px' ? 'center' : 'flex-start')};
`;

const SkeletonLine = styled.div`
  height: 12px;
  width: 100%;
  background: linear-gradient(
    90deg,
    #444 0%,
    #555 50%,
    #444 100%
  );
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

const SkeletonCheckbox = styled.div`
  width: 18px;
  height: 18px;
  background: linear-gradient(
    90deg,
    #444 0%,
    #555 50%,
    #444 100%
  );
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 3px;
  border: 1px solid #555;

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

export default RiderTableSkeleton;